import {
  GlobalServiceService,
  UserObj,
} from "./../../core/services/global-service.service";
import { LanguageService } from "./../../core/services/language.service";
import { Component, OnInit, Output, EventEmitter, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { AuthenticationService } from "../../core/services/auth.service";
import { AuthfakeauthenticationService } from "../../core/services/authfake.service";

import { environment } from "../../../environments/environment";
import { CompaniesService } from "src/app/core/services/companies.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { MsalService } from "@azure/msal-angular";
import { AuthService } from "src/app/core/services/auth/auth.service";

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"],
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {
  element;
  configData;
  selectedCompany;
  user: UserObj;
  role;
  token;

  constructor(
    private modalService: NgbModal,
    private authS: AuthenticationService,
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private authService: AuthService,
    private authFackservice: AuthfakeauthenticationService,
    private lang_service: LanguageService,
    private sso_authService: MsalService
  ) {}

  openMobileMenu: boolean;

  loading: boolean = false;

  lang: string = "default";
  flag: string = "assets/images/flags/us.jpg";

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    this.user = this.authService.getUserInfo() as unknown as UserObj;
    this.role = this.user.roleName;

    this.openMobileMenu = false;
    this.element = document.documentElement;

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.lang_service.lang.subscribe((lang) => {
      this.lang = lang;
      if (lang == "en") {
        this.flag = "assets/images/flags/us.jpg";
      } else if (lang == "it") {
        this.flag = "assets/images/flags/italy.jpg";
      }
    });
  }

  switch_lang(lang: string) {
    this.lang_service.switchLang(lang);
  }

  infoModal(infoDataModal: any) {
    // this.c_service.searchFromId(this.token).subscribe((res) => {
    //   this.selectedCompany = res;
    // });
    // this.modalService.open(infoDataModal, { size: "lg", centered: true });
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    // if (environment.defaultauth === "firebase") {
    //   this.authService.logout();
    // } else {
    //   this.authFackservice.logout();
    // }
    this.authService.logout().subscribe((result) => {
      const currentAccount = this.sso_authService.instance.getAllAccounts()[0];
      if (currentAccount) {
        this.sso_authService.logoutRedirect().subscribe((result) => {
          this.router.navigate(["/account/login"]);
        });
      } else {
        this.router.navigate(["/account/login"]);
      }
    });

    // this.sso_authService.logoutPopup().subscribe({
    //   next: (result) => {
    //     console.log("SSO RESULT", result);
    //     if (result == undefined) {
    //       return;
    //     }
    //     this.router.navigate(["/account/login"]);
    //   },
    //   error: (error) => console.log(error),
    // });
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle("fullscreen-enable");
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
}
